import { signal } from "@preact/signals-react";

// Template History Data
export const templateHistoryData = signal([]);
export const templateHistoryStatus = signal("idle"); // idle | loading | loaded | error
export const templateHistoryError = signal(null);
export const templateContinuationToken = signal(null);
export const templateHasMore = signal(false);
